const condensedReport = {
  condensedReport: 'Informe Condensado',
  sites: 'Sites',
  equipmentModels: 'Tipo de Equipo',
  equipmentServices: 'Tipo de Servicio',
  buttonText: 'Exportar Informe',
  from: 'Desde',
  to: 'Hasta',
};

export default condensedReport;
